import React from 'react';
import './ModuleView.css'

function ModuleView(props) {
    return (
        <div className="module-view">
            <p><b>Module: </b><a href={"https://www.codecademy.com/learn/" + props.parentTrackSlug + "/modules/" + props.module.slug} target="_blank" rel="noreferrer">{props.module.title}</a></p>
            <p><b>slug: </b>{props.module.slug}</p>             
            <p><b>Description: </b> {props.module.shortDescription}</p>
        </div>
    )
}

export default ModuleView;